// extracted by mini-css-extract-plugin
export default {"napsa-header":"NapsaReport_napsa-header__aaw6P","divider":"NapsaReport_divider__UnPzi"};